<script>
    import Navigation from "./components/Navigation.svelte";
    import Header from "./components/sections/Header.svelte";
    import About from "./components/sections/About.svelte";
    import Artists from "./components/sections/Artists.svelte";
    import Events from "./components/sections/Events.svelte";
    import Contact from "./components/sections/Contact.svelte";
    import Loading from "./components/Loading.svelte";

    import fetchContent from "./sanity.js";
  const query = '*[_type == "sections"][0]{ about, artists, copyright, contact }';
  const content = fetchContent(query);

</script>

<Navigation />
<Header />
{#await content}
<Loading />
{:then result}
<About about={result.about}/>
<Artists intro={result.artists} copyright={result.copyright}/>
<Events />
<Contact contact={result.contact}/>
{/await}